import { loginActionData } from './login/login-action';
import { emailActionData } from './email/email-action';
import { accountActions } from './account-action';
import { navigationActionData } from './navigation-action';
import { collectionActions } from './collectionAction';
import { modalActions } from './modal-action';
import { smsActionData } from './sms/sms-action';
import { refreshActions } from './refreshAction';
import { showComponentActions } from './showComponentAction';
import { hideComponentActions } from './hideComponentAction';
import { externalApiActions } from './externalApiAction';
import { importExportAcions } from './importExportAction';
import { formActions } from './formAction';
import { browserActions } from './browserAction';
import { multiTenantActions } from './multiTenantAction';
import { chatGPTActions } from './chatGPTActions';
import { permissionActionData } from './permission-action';
import { supabaseActions } from './externalSource/supabaseAction';
import { verify2FAData } from './login/2FA';
import { imaginePayActions } from './imaginePayAction';
import { amazonTextractActions } from './amazonTextractAction';
import { directusActions } from './externalSource/directusAction';
import { appwriteActions } from './externalSource/appwriteAction';
import { xanoActions } from './externalSource/xanoAction';
import { updateCellDataAction } from './tabulator/updateCellDataAction';
import { loanActions } from './loanActions';
import { oAuth2ActionData } from './login/oAuth2/oAuth-actions';
import { docusignActionData } from './docusign/docusign-action';
import { otpAuthenticatorActions } from './otpAuthenticator/otpAuthenticatorActions';
import { textAnonymizationActionData } from './text-anonymization/text-anonymization-action';
import { typesenseSearchActions } from './typesense-search/typesenseSearchActions';
import { triggerCustomFunction } from './customFunction/triggerCustomFunction';
import { socketActionData } from './socket-io/socketIOActions';
import { metaDataTableActions } from './metaData/metaDataAction';
import { signzyActions } from './signzy/signzyActions';
import { googleActions } from './google/googleActions';
import { pineconeActions } from './pinecone/pineconeActions';
import { aiChatbotActions } from './ai-chatbot/aiChatbotActions';
import { zoomActions } from './zoom/zoomActions';
import { cibilActions } from './cibil/cibilActions';
import { mysqlActions } from './externalSource/mysqlAction';
import { boxActions } from './box/boxActions';
import { qrActions } from './qr/qrActions';
import { mPesaActions } from './m-pesa/mPesaActions';
import { spinMobileActions } from './spin-mobile/spinMobileActions';
import { pdfActions } from './pdf/pdfActions';
import { miscActions } from './misc/miscAction';
import { signaturePadActions } from './signature-pad/signaturePadAction';
import { boldSignActions } from './boldsign/boldSignActions';
import { pdfViewerActions } from './pdf/pdfViewerActions';

export const ActionCategoryList = [
  {
    category: 'Login / Signup',
    items: loginActionData,
  },
  {
    category: 'Snippet / Modal Popup',
    items: modalActions,
  },

  {
    category: 'Show / Hide Sections',
    items: [...showComponentActions, ...hideComponentActions],
  },
  {
    category: 'Navigation',
    items: [...navigationActionData, ...refreshActions],
  },
  {
    category: 'Notification',
    items: [...emailActionData, ...smsActionData, ...accountActions, ...socketActionData],
  },
  {
    category: 'Collection',
    items: collectionActions,
  },
  { category: 'Multi Tenant', items: multiTenantActions },
  {
    category: 'External APIs',
    items: externalApiActions,
  },
  // {
  //   category: 'Supabase',
  //   items: supabaseActions,
  // },
  // {
  //   category: 'Directus',
  //   items: directusActions,
  // },
  // {
  //   category: 'Appwrite',
  //   items: appwriteActions,
  // },
  // {
  //   category: 'Xano',
  //   items: xanoActions,
  // },
  // {
  //   category: 'MySQL',
  //   items: mysqlActions,
  // },
  // {
  //   category: 'Tabulator',
  //   items: updateCellDataAction,
  // },
  // {
  //   category: 'Custom Function',
  //   items: triggerCustomFunction,
  // },
  {
    category: 'OAuth2.0',
    items: oAuth2ActionData,
  },
  {
    category: 'AI / ChatGPT',
    items: chatGPTActions,
  },
  {
    category: 'Import / Export Collection Data',
    items: importExportAcions,
  },
  {
    category: 'Permission',
    items: permissionActionData,
  },
  { category: '2 Factor Authentication', items: verify2FAData },
  { category: 'Imagine Pay', items: imaginePayActions },
  { category: 'Loan Management', items: loanActions },
  { category: 'OCR to Text', items: amazonTextractActions },
  { category: 'OTP Authentication', items: otpAuthenticatorActions },
  { category: 'Typesense Search', items: typesenseSearchActions },
  { category: 'Meta Data Table', items: metaDataTableActions },
  { category: 'Signzy', items: signzyActions },
  { category: 'Google', items: googleActions },
  { category: 'Zoom', items: zoomActions },
  { category: 'Docusign', items: docusignActionData },
  { category: 'Text Anonymization', items: textAnonymizationActionData },
  { category: 'Pinecone', items: pineconeActions },
  { category: 'AI Chatbot', items: aiChatbotActions },
  { category: 'CIBIL', items: cibilActions },
  { category: 'Box', items: boxActions },
  { category: 'QR', items: qrActions },
  { category: 'M-Pesa', items: mPesaActions },
  { category: 'Spin Mobile', items: spinMobileActions },
  { category: 'Signature Pad', items: signaturePadActions },
  { category: 'BoldSign', items: boldSignActions },
  {
    category: 'Data Sources',
    type: 'datasource',
    subCategories: [
      {
        name: 'Supabase',
        category: 'Supabase',
        items: supabaseActions,
      },
      {
        name: 'Directus',
        category: 'Directus',
        items: directusActions,
      },
      {
        name: 'Appwrite',
        category: 'Appwrite',
        items: appwriteActions,
      },
      {
        name: 'Xano',
        category: 'Xano',
        items: xanoActions,
      },
      {
        name: 'MySQL',
        category: 'MySQL',
        items: mysqlActions,
      },
    ],
  },

  // Keep this category always at the end.
  {
    category: 'Others',
    subCategories: [
      {
        name: 'Custom Function',
        category: 'Custom Function',
        items: triggerCustomFunction,
      },
      {
        name: 'Tabulator',
        category: 'Tabulator',
        items: updateCellDataAction,
      },
      {
        name: 'Generate PDF',
        category: 'generatePdfFromSnippet',
        items: pdfActions,
      },
      {
        name: 'PDF Viewer',
        category: 'PDF Viewer',
        items: pdfViewerActions,
      },

      {
        name: 'Form',
        category: 'Form',
        items: [...formActions],
      },
      { name: 'Browser Storage', category: 'Browser Storage', items: [...browserActions] },
      {
        name: 'Misc',
        category: 'Misc',
        items: miscActions,
      },
    ],
  },
];

export const ActionList = [
  ...loginActionData,
  ...emailActionData,
  ...smsActionData,
  ...accountActions,
  ...modalActions,
  ...navigationActionData,
  ...collectionActions,
  // ...dataSourceActions,
  ...refreshActions,
  ...showComponentActions,
  ...hideComponentActions,
  ...externalApiActions,
  ...chatGPTActions,
  ...importExportAcions,
  ...formActions,
  ...browserActions,
  ...multiTenantActions,
  ...supabaseActions,
  ...directusActions,
  ...appwriteActions,
  ...xanoActions,
  ...mysqlActions,
  ...updateCellDataAction,
  ...verify2FAData,
  ...imaginePayActions,
  ...loanActions,
  ...oAuth2ActionData,
  ...amazonTextractActions,
  ...docusignActionData,
  ...otpAuthenticatorActions,
  ...textAnonymizationActionData,
  ...typesenseSearchActions,
  ...triggerCustomFunction,
  ...socketActionData,
  ...metaDataTableActions,
  ...signzyActions,
  ...googleActions,
  ...pineconeActions,
  ...aiChatbotActions,
  ...zoomActions,
  ...cibilActions,
  ...boxActions,
  ...qrActions,
  ...mPesaActions,
  ...spinMobileActions,
  ...pdfActions,
  ...pdfViewerActions,
  ...miscActions,
  ...signaturePadActions,
  ...boldSignActions,
];
